<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section" style="background-image:url(/static/images/hero-connection.png)">
      <div class="hero-section-text row column">
        <h1>Oops, looks like we can't connect you.</h1>
      </div>
    </div>
    <section id="mainContent" class="row column">
      <h2>Why can't I sign up?</h2>
      <p>Unfortunately it looks like you're not eligible for signing up to Workplace.</p>
      <p>If you're unsure why, or think we've got this wrong, speak to your line manager.</p>
      
      <p>If you've access to the BT intranet, head to FixIT where we have <a href="https://fixit.bt.com/pages/browsebysubject.aspx?contentcenter=Workplace%20by%20Facebook">lots of articles</a> about Workplace.</p>

    </section>
  </div>
</template>

<script>
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import {fixitContentCentre} from '../commonError'

export default {
  name: 'ErrorNotProvisioned',
  title: "Workplace - You're not enabled as yet",
    data: function() {
    return {
      fixitContentCentre: fixitContentCentre
    }
  }
}

</script>
